import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import NavBar from "./NavBar";
import TopBar from "./TopBar";
import { styled } from "@mui/material";

const Root = styled("div")(({ theme }) => ({
	display: "flex",
	height: "100%",
	overflow: "hidden",
}));

const Wrapper = styled("div")(({ theme }) => ({
	display: "flex",
	flex: "1 1 auto",
	overflow: "hidden",
	paddingTop: 100,
	[theme.breakpoints.up("md")]: {
		paddingLeft: 190,
	},
}));

const ContentContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flex: "1 1 auto",
	overflow: "hidden",
}));

const Content = styled("div")(({ theme }) => ({
	flex: "1 1 auto",
	height: "100%",
	overflow: "auto",
}));

const AdminNavBar = () => {
	const [isMobileNavOpen, setMobileNavOpen] = useState(false);
	useEffect(() => {
		console.log(isMobileNavOpen);
	}, [isMobileNavOpen]);

	return (
		<Root>
			<TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
			<NavBar
				onMobileClose={() => setMobileNavOpen(false)}
				openMobile={isMobileNavOpen}
			/>
			<Wrapper>
				<ContentContainer>
					<Content>
						<Outlet />
					</Content>
				</ContentContainer>
			</Wrapper>
		</Root>
	);
};

export default AdminNavBar;
